<div class="p-grid content-cedi">
  <div class="p-col-12">
    <h1>CEDI/Tiendas</h1>
  </div>
  <div>
    <h3 class="first">Seleccione una Empresa para listar o crear Cedi</h3>
    <p-autoComplete
      *ngIf="companies != null"
      name="company"
      [(ngModel)]="selectedCompany"
      field="name"
      [suggestions]="filteredCompanies"
      (completeMethod)="filterCompanies($event)"
      (onSelect)="updateClientPoints($event)"
      [forceSelection]="true"
      [size]="30"
      [minLength]="1"
      placeholder="Ingresa el nombre de la empresa"
      [dropdown]="true"
    >
      <ng-template let-brand pTemplate="item">
        {{ brand.name }}
      </ng-template>
    </p-autoComplete>
  </div>
</div>
<div class="p-col-12 content-cedi_load-address_header">
  <div class="p-grid create_address">
    <p-button class="p-col-4" label="Cargar tiendas con xls" routerLink="/cedi/load"></p-button>
    <p-button class="p-col-6" label="Crear Puntos" [disabled]="!selectedCompany" (click)="handleNewPoint()"></p-button>
  </div>
</div>

<div class="p-col-12">
  <div class="p-col-12 content-list-ceditable" *ngIf="selectedCompany">
    <p-table [value]="clientPoints" [paginator]="true" [rows]="10" [(first)]="first">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">Ciudad</th>
          <th scope="col">Dirección</th>
          <th scope="col">Nombre</th>
          <th scope="col"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-cp>
        <tr>
          <td>{{ cp.city }}</td>
          <td>{{ cp.address }}</td>
          <td>{{ cp.name }}</td>
          <td class="edit-buttons">
            <div (click)="updateCediPoint(cp)">
              <i class="pi pi-user-edit" style="font-size: 3em" aria-hidden="true"></i>
            </div>
            <div (click)="deletePointAddress(cp.id)">
              <i class="pi pi-times" style="font-size: 3em" aria-hidden="true"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="Editar punto" [(visible)]="showEditCedi" [style]="{ width: '50vw' }">
  <app-create-cedi-point
    [cities]="cities"
    [country]="selectedCountry"
    [labelbutton]="labelButtonCedi"
    [company]="selectedCompany"
    [filtercities]="filteredCities"
    [cediToEdit]="editPointCEdi"
    (closecedimodal)="handleEditCedi($event)"
    (showtoast)="showSuccess()"
    (filteredcities)="filterCities($event)"
  ></app-create-cedi-point>
</p-dialog>

<p-dialog header="Nuevo punto" [(visible)]="showCreateCedi" [style]="{ width: '50vw' }">
  <app-create-cedi-point
    [cities]="cities"
    [country]="selectedCountry"
    [labelbutton]="labelCreateCedi"
    [company]="selectedCompany"
    [filtercities]="filteredCities"
    (closecedimodal)="handleNewPoint()"
    (showtoast)="showSuccess()"
    (filteredcities)="filterCities($event)"
  ></app-create-cedi-point>
</p-dialog>

<p-dialog header="" [(visible)]="showDeleteCedi" [style]="{ width: '50vw' }">
  <div class="content-delete-address">
    <div class="content-delete-address_warning">
      <h2>¿Eliminar dirección?</h2>
      <p>La dirección se borrará definitivamente de la lista de lugares.</p>
    </div>
    <div class="content-delete-address_buttons">
      <button (click)="validateDeleteAddress(false)" pButton label="Volver" class="btn-address_delete"></button>
      <button (click)="validateDeleteAddress(true)" pButton label="Eliminar" class="ui-button-danger btn-address_delete"></button>
    </div>
  </div>
</p-dialog>

<p-toast></p-toast>
